import React, { useState,useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const WalletBreakdownTable = ({ walletBreakDown }) => {
  const [walletBreakdownData, setWalletBreakDownData] = useState([])

    // check if the the value is an empty string or null
    const isEmptyChecker = (data) => (!data || '' ? '--' : data);

  useEffect(() => {
    setWalletBreakDownData(walletBreakDown)
  }, [setWalletBreakDownData])

  const table_data = (
    walletBreakdownData.map((data) => {
      const attribute = data.attributes;

      const amount = _.get(attribute, 'credit') !== (0.0).toFixed(2) ? (
        <span className="" style={{ color: '#28a745'}}>
          <i className="fas fa-arrow-up mr-1" />
          { isEmptyChecker(_.get(attribute, 'credit')) }
        </span>
      ) : (
        <span className="neg">
          <i className="fas fa-arrow-down mr-1" />
          { isEmptyChecker(_.get(attribute, 'debit')) }
        </span>
      )

      return (
        <tr key={data.id} className="">
          <td className=""> {isEmptyChecker(_.get(attribute, 'paid_at'))}</td>
          <td className=""> {amount}</td>
          <td className=""> {isEmptyChecker(_.get(attribute, 'remaining_balance'))}</td>
          <td className="">
            {' '}
            {isEmptyChecker(_.get(attribute, 'transaction_biller'))}
          </td>
          <td className="">
            {' '}
            {isEmptyChecker(_.get(attribute, 'transaction_description'))}
          </td>
        </tr>
      );
    })
  )

  // Todo: will map data here later
  return (
    <div className="container-fluid px-2">
      <div className="row mt-4">
        <div className="px-0 col-12 d-none d-md-block">
          <div
            className="overflow-auto"
            style={{ minHeight: '300px', height: '55vh' }}
          >
            {/* Table */}
            <table className="table table-striped table-link table-hover table-light">
              <thead className="">
                {/* header */}
                <tr>
                  <th className="text-center bg-primary text-white sticky-top">
                    Date Paid
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Amount
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Remaining Balance
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Transaction Biller
                  </th>
                  <th className="text-center bg-primary text-white sticky-top">
                    Transaction Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {table_data}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

WalletBreakdownTable.propTypes = {
  walletBreakDown: PropTypes.instanceOf(Object).isRequired,
};

export default WalletBreakdownTable;
